import "slick-carousel";

$(".carousel").swipe({

    swipe: function (event, direction, distance, duration, fingerCount, fingerData) {

        if (direction == 'left') $(this).carousel('next');
        if (direction == 'right') $(this).carousel('prev');

    },
    allowPageScroll: "vertical"

});

$(document).ready(function () {
    $('.js-news-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        focusOnSelect: true,
        arrows: true,
        prevArrow: $('.js-news-carousel-prev'),
        nextArrow: $('.js-news-carousel-next')
    });
});
